import { useCompanyQuery } from './useCompanyQuery';
import { useBasicCompanyQuery } from './generated';

export function useBasicCompany() {
  return useCompanyQuery(useBasicCompanyQuery)
}
